import React, { FC, useEffect } from "react";
import { updateParentStyle } from "../../utils/connector";

const RemoveChat: FC = () => {
  useEffect(() => {
    updateParentStyle({
      display: "none",
    });
  }, []);

  return <div></div>;
};

export default RemoveChat;
